import { scrollToElement } from "../utils/shared";

jQuery(function ($) {
  // Only initialize FacetWP listeners if FacetWP is available
  if (typeof FWP !== "undefined") {
    $(document).on("facetwp-loaded", function () {
      $(".js-facet-wrapper").each(function () {
        if (!FWP.settings || !FWP.settings.num_choices) {
          return;
        }

        const $wrapper = $(this);
        const facetKey = $wrapper.data("facet");

        // Get number of choices for this facet
        const numChoices = FWP.settings.num_choices[facetKey] || 0;
        $wrapper.toggle(numChoices > 0);
      });
    });
  }

  // Add category navigation
  $(".js-category-toggle").on("click", function (e) {
    e.preventDefault();
    const $header = $(this).closest(".js-category-header");
    const $sublist = $header.siblings(".js-subcategory-list");

    $sublist.slideToggle(200);
    $(this).toggleClass("rotate-180");
  });

  const initSidebar = () => {
    const $sidebar = $(".js-product-sidebar");
    const $toggler = $(".js-sidebar-toggler");
    const $iconOpen = $(".js-sidebar-icon-open");
    const $iconClose = $(".js-sidebar-icon-close");
    const $sidebarCloseBtn = $(".js-sidebar-close-btn");

    let isSidebarManuallyOpen = false;

    if (window.innerWidth < 1024) {
      $sidebar.hide();
      $iconOpen.show();
      $iconClose.hide();
    }

    $sidebarCloseBtn.on("click", function () {
      isSidebarManuallyOpen = false;
      $sidebar.slideUp(200);
      $iconOpen.show();
      $iconClose.hide();
    });

    $toggler.on("click", function () {
      isSidebarManuallyOpen = !isSidebarManuallyOpen;
      $sidebar.slideToggle(200, () => {
        // After toggle is complete, scroll if opening on mobile
        if (isSidebarManuallyOpen && window.innerWidth < 1024) {
          scrollToElement($sidebar, 20); // 20px offset from top
        }
      });
      $iconOpen.toggle();
      $iconClose.toggle();
    });

    // Handle resize events
    $(window).on("resize", function () {
      if (window.innerWidth < 1024) {
        // Only hide if not manually opened
        if (!isSidebarManuallyOpen) {
          $sidebar.hide();
          $iconOpen.show();
          $iconClose.hide();
        }
      } else {
        // On desktop - always visible
        $sidebar.show();
      }
    });
  };

  initSidebar();
});
